import React from 'react';

const SvgPr = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="PR_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
      <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="PR_svg__e">
        <stop stopColor="#FFF" offset="0%" />
        <stop stopColor="#F0F0F0" offset="100%" />
      </linearGradient>
      <path
        id="PR_svg__d"
        d="M4.667 11.274l-1.96 1.423.748-2.303L1.496 8.97h2.422l.749-2.303.749 2.302h2.42l-1.958 1.425.748 2.303z"
      />
      <filter
        x="-5.1%"
        y="-7.5%"
        width="110.1%"
        height="120.5%"
        filterUnits="objectBoundingBox"
        id="PR_svg__c"
      >
        <feOffset dy={1} in="SourceAlpha" result="shadowOffsetOuter1" />
        <feColorMatrix
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
          in="shadowOffsetOuter1"
        />
      </filter>
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="PR_svg__b" fill="#fff">
        <use xlinkHref="#PR_svg__a" />
      </mask>
      <rect
        stroke="#F5F5F5"
        strokeWidth={0.5}
        x={0.25}
        y={0.25}
        width={27.5}
        height={19.5}
        rx={2}
      />
      <path
        d="M28 12H0V8h28v4zm0 4v4H0v-4h28zm0-12H0V0h28v4z"
        fill="#FA2222"
        mask="url(#PR_svg__b)"
      />
      <path fill="#1D63F9" mask="url(#PR_svg__b)" d="M0 0l13.333 10L0 20z" />
      <g mask="url(#PR_svg__b)">
        <use fill="#000" filter="url(#PR_svg__c)" xlinkHref="#PR_svg__d" />
        <use fill="url(#PR_svg__e)" xlinkHref="#PR_svg__d" />
      </g>
    </g>
  </svg>
);

export default SvgPr;
